/**
 * A link that may or may not leave this platform.
 *
 * TodAi is two sites on two origins (src/config/platform.ts). A route that is
 * internal in the planner build — `/cctv-design`, say — is a different origin
 * from the shop, and react-router's <Link> would turn that absolute URL into a
 * relative path and 404. This picks the right element from the href itself, so
 * a call site can pass plannerUrl(...) without knowing which build it is in.
 */
import { Link } from 'react-router-dom';
import type { ComponentProps, ReactNode } from 'react';

type Props = Omit<ComponentProps<'a'>, 'href'> & { href: string; children: ReactNode };

export default function PlatformLink({ href, children, ...rest }: Props) {
  if (/^[a-z]+:\/\//i.test(href)) {
    // Crossing to the sibling platform. No rel="noopener" dance — this is a
    // same-tab navigation to a site we operate, not an untrusted outbound link.
    return <a href={href} {...rest}>{children}</a>;
  }
  return <Link to={href} {...rest}>{children}</Link>;
}
